import axios from 'axios';
import * as dateUtil from "@Utils/DateUtils";
import { createGuid, getLanguage, isEmpty } from './StringUtils';

let reqCnt = 0 ;
let resCnt = 0 ;

export function kakaoLink(options:any){
     const win: any = window;
     win.Kakao.Link.sendDefault(options);
}
export function getSysCd() {
     return window.location.href.indexOf('bok.or.kr') !== -1 ? '05' : '01';
}

export async function callService(trxCd: string, param?: any, options?:any) {

     let dim = true;
     let errorMsgFlag = true;
     const sysCd =  getSysCd();
     const ipAddr = getIpAddr();
     const langCd = getLanguage().toUpperCase();
     const sndDtm = dateUtil.formatDate('yyyyMMddHHmmssSSS');
     const fstChnCd = "WEB";

     let hash = ('_'+window.location.pathname+window.location.hash);
     let scrId = sessionStorage.getItem(hash);
     
     if(isEmpty(scrId)){
          while(hash.lastIndexOf('/') !== -1){
               hash = hash.substr(0,hash.lastIndexOf('/'));
               scrId = sessionStorage.getItem(hash);
               if(scrId){
                    break;
               }
          }
          if(isEmpty(scrId)){
               scrId = 'RECRUIT';
          }
     }
     
     const userInfoStr:any = sessionStorage.getItem('userInfo');
     const userInfo = JSON.parse(userInfoStr);
     if(options){
          if(isEmpty(options['dim']) === false){
               dim = options['dim'];
          }

          if(isEmpty(options['errorMsgFlag']) === false){
               errorMsgFlag = options['errorMsgFlag'];
          }
     }

     let sendData = {
          header: {
               "guidSeq": 1,
               "trxCd": trxCd,
               "scrId": scrId,
               "sysCd": sysCd,
               "fstChnCd": fstChnCd,
               "langDvsnCd": langCd,
               "envDvsnCd": "D",
               "sndRspnDvsnCd": "S",
               "sndDtm": sndDtm,
               "ipAddr": ipAddr,
               "usrId": userInfo ? userInfo['usrId'] : 'RECRUIT',
               "pageNum" : 1,
               "pageCnt" : 1000,
          },
          data : param ? param : {}
     };
     
     reqCnt++;

     let loading:any = document.querySelector('.loading');

     if(dim && loading && loading.classList.contains('displayNone')){
          loading.classList.remove('displayNone');
     }
     
     const res = await axios.post("/serviceEndpoint/httpService/request.json", sendData);

     resCnt++;
     
     if(loading && loading.classList.contains('displayNone') === false && reqCnt === resCnt){
          loading.classList.add('displayNone');
     }
     
     if(res['data']['header']['rspnDvsnCd'] !== "0" && res['data']['message']['detailMsgs'].length !== 0){

          if(errorMsgFlag){
               const msg = res['data']['message']['detailMsgs'][0];

               if(msg['msgCd'] === 'BBME00038'){
                    sessionStorage.clear();
                    window.location.reload()
               }else{
                    alert(msg['msgCtnt']);
               }
               return;
          }else{
               return res['data']['message'];
          }
          
     }
     
     return res['data']['data'];
}

export function getIpAddr() {
     return localStorage.getItem('ipAddr');
}

export async function niceCheckDecode(encodeData:string) {
     const res = await axios.get("/serviceEndpoint/niceCheckDecode?encodeData="+encodeURIComponent(encodeData));

     if(res['data']){
          const errorCode = res['data']['resCode'];
          if (errorCode === 0) {
               return res['data'];
          }else if (errorCode === -1) {
               alert("암호화 시스템 에러입니다.");
          }else if( errorCode === -1){
               alert("복호화 시스템 에러입니다.");
          }else if( errorCode === -4){
               alert("복호화 처리오류입니다.");
          }else if( errorCode === -5){
               alert("복호화 해쉬 오류입니다.");
          }else if( errorCode === -6){
               alert("복호화 데이터 오류입니다.");
          }else if( errorCode === -9){
               alert("입력 데이터 오류입니다.");
          }else if( errorCode === -12){
               alert("사이트 패스워드 오류입니다.");
          }else{
               alert("알수 없는 에러 입니다. errorCode : " + errorCode);
          }
     
     }
}


export async function niceCheck(url:string) {

     const createHiddenInput = (name: string, value: string) => {
          const input = document.createElement("input");
          input.setAttribute("type", "hidden");
          input.setAttribute("name", name);
          input.setAttribute("value", value);
          return input;
     }
 
     const returnUrl = encodeURIComponent("/recruit/#"+url);

     const res = await axios.get("/serviceEndpoint/niceCheckReq?returnUrl="+returnUrl);

     if(res['data']){

          const errorCode = parseInt(res['data']);
          if(errorCode){
               if (errorCode === -1) {
                    alert("암호화 시스템 에러입니다.");
               } else if (errorCode === -2) {
                    alert("암호화 처리오류입니다.");
               } else if (errorCode === -3) {
                    alert("암호화 데이터 오류입니다.");
               } else if (errorCode === -9) {
                    alert("입력 데이터 오류입니다.");
               } else {
                    alert("알수 없는 에러 입니다. Code : " + errorCode);
               }
          }else{
               window.open('', 'popupChk', 'width=480, height=800, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
          
               const checkForm = document.createElement("form");
          
               checkForm.setAttribute("charset", "UTF-8");
               checkForm.setAttribute("method", "post");
               checkForm.setAttribute("target", "popupChk");
               checkForm.setAttribute("action", "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb");
          
               checkForm.appendChild(createHiddenInput('m', 'checkplusSerivce'));
               checkForm.appendChild(createHiddenInput('EncodeData', res['data']));
          
               document.body.appendChild(checkForm);
          
               checkForm.submit();
               checkForm.remove();
          }
     }
}